import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Profile } from "../../components";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import AppContext from "../../AppContext";
import NewProject from "../../components/NewProject";
import { useSearchParams } from "react-router-dom";

const UserProfile = ({ userId }) => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();

  const handleEditProfile = () => {
    navigate("/profile/edit");
  };

  const handleNewProject = () => {
    navigate("/new-project");
  };

  return (
    <Profile
      id={id}
      isCompany={false}
      onEdit={handleEditProfile}
      onNewProject={handleNewProject}
      viewMode={searchParams.get("view")}
    />
  );
};

UserProfile.propTypes = {
  userId: PropTypes.string,
};

const OwnerProfile = () => {
  return (
    <Routes>
      <Route path="" element={<UserProfile />} />
      <Route path="edit" element={<Profile isCompany={false} edit />} />
    </Routes>
  );
};

const ProfilePage = (props) => {
  return (
    <Routes>
      <Route path="profile/*" element={<OwnerProfile />} />
      <Route path=":id" element={<UserProfile />} />
    </Routes>
  );
};

ProfilePage.propTypes = {};

export default ProfilePage;
